// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__NHIpZ","info":"Note_info__1e_-u","note":"Note_note__2_1S3","actions":"Note_actions__K3Pub"};